import React from 'react';
import { useIntl } from 'ha/i18n';
import { makeStyles } from 'tss-react/mui';
import { Paper, Typography, units } from '@hbf/dsl';

import { MAX_IMAGES_PER_COL } from './constants';

const useStyles = makeStyles()({
  paperRoot: {
    backgroundColor: 'rgba(0,0,0,0.5)',
    justifyContent: 'center',
    padding: units.trbl(0, 1, 0, 1),
    position: 'absolute',
    alignItems: 'center',
    display: 'flex',
    bottom: 0,
    right: 0,
    left: 0,
    top: 0,
  },
  gradient: {
    background:
      'linear-gradient(to bottom, rgba(0,0,0,0.5) 0, transparent 50%)',
  },
});

interface Props {
  tilesLength?: number;
  showText?: boolean;
  showGradient?: boolean;
}

export const ImageGridOverlay: React.FC<Props> = ({
  tilesLength,
  showText = true,
  showGradient = false,
}) => {
  const { T } = useIntl();
  const { classes, cx } = useStyles();

  return (
    <Paper
      className={cx(classes.paperRoot, {
        [classes.gradient]: showGradient,
      })}
    >
      <Typography.H4 align="center" color="white">
        {showText &&
          tilesLength &&
          T('%s more photos available', tilesLength - MAX_IMAGES_PER_COL)}
      </Typography.H4>
    </Paper>
  );
};
